import axios from 'axios';

// Interceptor global para manejar expiración de sesión (401)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('authToken');
      // Opcional: puedes mostrar un mensaje aquí si quieres
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
// Utilidad para obtener headers de autenticación
// Usar este helper en todas las llamadas API que requieran autenticación

/**
 * Obtiene los headers de autorización con el token JWT del localStorage
 * @returns {Object} Headers con Authorization Bearer token
 */
export const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

/**
 * Obtiene headers completos incluyendo Content-Type y Authorization
 * @returns {Object} Headers completos para peticiones
 */
export const getFullHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };
};

/**
 * Wrapper de fetch que automáticamente incluye headers de autenticación
 * @param {string} url - URL del endpoint
 * @param {Object} options - Opciones de fetch (method, body, etc.)
 * @returns {Promise<Response>}
 */
export const authenticatedFetch = async (url, options = {}) => {
  const headers = {
    ...getFullHeaders(),
    ...(options.headers || {})
  };

  return fetch(url, {
    ...options,
    headers
  });
};

export default {
  getAuthHeaders,
  getFullHeaders,
  authenticatedFetch
};
